import React from "react";

// @material-ui/icons
import { CircularProgress } from '@mui/material';
import ComplexStatisticsCard from "components/Card/StatisticsCards/ComplexStatisticsCard";
import { Box } from '@mui/material';
import { Alert } from '@mui/material';

import { useQuery } from "react-query";
import { useToken } from "hooks/token.js";
import { useAxiosAuth } from "hooks/axios.js";

import axios from "axios";

export default function NodeCard(props) {
  const url = "/api/v1/k8s/nodes"
  const [token, setToken] = useToken();
  useAxiosAuth(token);

  const { isLoading, error, data } = useQuery(
    "node", () => axios.get(
      url,
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }
    ).then(
      (res) => (res.hasOwnProperty('data') && res.data.hasOwnProperty('data'))? res.data.data : null
    )
  )

  const nodeCount = (data) => {
    if (data) {
      return ("items" in data) ? data.items.length : 0;
    } else {
      return 0
    }
  }

  const osName = (data) => {
    if (data) {
      return ("items" in data && data.items.length) ? data.items[0]['operating_system'] : "Unknown";
    } else {
      return "Unknown"
    }
  }

  return (
    <React.Fragment>
      {error ?
        <Box sx={{ paddingBottom: "10px" }}>
          <Alert severity="error">
            "Error loading data"
          </Alert>
        </Box>
        : null
      }
      {isLoading && <CircularProgress size={24} style={{marginLeft: '8%', position: 'fixed', top: '20%',  zIndex: '10'}} />}
      <ComplexStatisticsCard
        color="dark"
        icon="Nodes"
        title="K8S Nodes"
        count={nodeCount(data)}
        percentage={{
          color: "success",
          amount: "OS:",
          label: osName(data),
          opacity : isLoading ? '0.7' : '1' ,
          link: ""
        }}
      />
    </React.Fragment>
  );
}
